import { useFormContext, useWatch } from 'react-hook-form';
import { PropertySettingsMainTabFormValues } from '../../PropertySettingsMainTab.schema';
import { PropertyPhotoFile } from './PropertyDetails.types';

type SelectedFile = PropertyPhotoFile | { uri: null };

const useCurrentSelectedFile = () => {
  const { setValue } = useFormContext();

  const fileUrl = useWatch<PropertySettingsMainTabFormValues>({
    name: 'propertyDetails.internalThumbnailUrl',
  });

  // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  const currentFile: SelectedFile =
    typeof fileUrl === 'string'
      ? { uri: fileUrl, contentType: '', sizeInBytes: 0, uploadItemName: '' }
      : null;

  const setCurrentFile = (file: SelectedFile) => {
    setValue('propertyDetails.internalThumbnailUrl', file.uri, {
      shouldDirty: true,
    });
  };

  return { currentFile, setCurrentFile };
};

export default useCurrentSelectedFile;
